// extracted by mini-css-extract-plugin
module.exports = {"button":"PricesPageChooseDietButton_button__3j0FQ","p":"PricesPageChooseDietButton_p__2GIZD"};